module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/new-car-bg-aa366d4dbb4eabd50b336391df15dc2e.png";